import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
// import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';


const NationalScienceDay2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/ScienceDay/6.webp`;




  

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}


  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      NATIONAL SCIENCE DAY CELEBRATIONS AT ISTRAC/ISRO
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 8 & 9     Date: 26 February 2026

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        On Thursday, 26 February 2026, students of Classes 8 and 9 represented the school at a two-day event organised at ISTRAC/ISRO as part of the National Science Day celebrations, commemorating the discovery of the Raman Effect by Sir C V Raman.
        <br></br>
        The programme included a quiz, model-making competition, debate and prize distribution ceremony. Students participated enthusiastically, demonstrating scientific knowledge, creativity and critical thinking.
        <br></br>
        Scientists from ISRO, Dr Shivani and Deputy Director Dr Sangamesh, evaluated the models and interacted with the participants. The valedictory function was attended by Director Dr Anil Kumar, Associate Director    Dr Raghavendra and Chief Guest Dr Archana Soam, whose presentation on star formation enriched students’ understanding.
        <br></br>
        Overall, the two-day National Science Day celebrations at ISTRAC/ISRO proved to be an enriching, educational and inspiring experience for all participants.
        <br></br>

        </Typography>
      </Box>    
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The true spirit of science lies in curiosity, observation and discovery.”


<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default NationalScienceDay2025;